import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("phone-input", () => {
    it("should format phone number correctly and match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-phone-input country="DE" value="0170 9000000" />`
        );
        const el = await page.find("ux-phone-input");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("dropdown should open on click and list all countries correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-phone-input country="DE" language="de" value="0170 9000000" />`
        );
        await page.find("ux-phone-input");
        await page.waitForChanges();
        const dropdownBtn = await page.find(".ux-phone-input__dropdown-button");
        dropdownBtn.click();
        await page.waitForChanges();
        const dropdown = await page.find(".ux-phone-input__dropdown");
        expect(dropdown).not.toBeNull();
        expect(dropdown).toMatchSnapshot();
    });

    it("should render label with required indicator", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-phone-input country="DE" label="Phone" required error-msg="Error Message"/>`
        );
        const el = await page.find("ux-phone-input");
        await page.waitForChanges();
        const input = await page.find("input[type=text]");
        await input.focus();
        await page.waitForChanges();
        await input.press("Space");
        await input.press("Backspace");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-phone-input country="DE" language="de" value="0170 9000000" />`
        );
    });
});
